import {
  DRAWER,
  DASHBOARD_LOADING,
  PROJECT_TAB_VALUE,
  DRAGGING_TYPE,
  DRAG_SELECTION,
  FILTER_VEHICLES_BY_STATUS,
  SET_CURRENT_WINDOW,
  SET_SETTINGS_SAVE_DISABLED,
  EXPANDED_ROUTES,
  SET_CURRENT_VEHICLE_SELECTION,
  SELECTED_ROUTES,
  RESET_STATE,
  SET_CURRENT_PROJECT_ID,
  SET_INFO_DIALOG_STATE,
  SET_INCOMPLETE_DRAWER_VISIBLE,
  SET_PROJECTS_DISABLED,
  SET_PUBLISH_DISABLED,
  SET_DISABLED_VEHICLES_VISIBILITY,
  EMPTY_ROUTES,
  EXPANDED_FROM_MAP,
  SET_UPLOAD_STOPS_OPEN,
  SET_UPLOAD_STOPS_SIMPLE_OPEN,
  SET_OPTIONS_EXPANDED,
  SET_STOP_TO_SCROLL_ID,
  SET_FILTER_STATUS,
  SET_STOP_SELECT_MODE,
  SET_STOP_SEARCH_MODE,
  SET_ROUTES_SEARCH_MODE,
  ADD_DRIVER_DIALOG_OPENED,
  SET_LOCKED_MATCH_STOP
} from "../actions/types";

const initialState = {
  drawerOpen: true,
  projectsDisabled: false,
  dashboardLoading: false,
  projectTabValue: 0,
  draggingType: "",
  currentProjectId: null,
  settingsSaveDisabled: true,
  optionsExpanded: false,
  currentWindow: "Project",
  filterStatus: "All vehicles",
  currentVehicleSelection: [],
  filteredVehicles: [],
  selectedRoutes: [],
  emptyRoutesVisible: true,
  disabledVehiclesVisible: true,
  dragSelection: {
    listId: "",
    list: []
  },
  expandedRoutes: [],
  expandedFromMap: false,
  infoDialog: {
    open: false,
    title: "",
    body: ""
  },
  uploadStopsOpen: false,
  uploadStopsSimpleOpen: false,
  incompleteAccountVisible: false,
  publishDisabled: false,
  stopToScrollId: null,
  isStopSearchMode: false,
  isStopSelectMode: false,
  isRoutesSearchMode: false,
  addDriverDialogOpened: false,
  // FOJW contextual RouteTag: the unscheduled stop whose match is "pinned" — its
  // matching routes stay highlighted and sorted to the top of the routes list.
  lockedMatchStopId: null
};

export function commonReducer(state = initialState, action) {
  switch (action.type) {
    case DRAWER:
      return {
        ...state,
        drawerOpen: action.val
      };
    case SET_SETTINGS_SAVE_DISABLED:
      return {
        ...state,
        settingsSaveDisabled: action.val
      };
    case DASHBOARD_LOADING:
      return {
        ...state,
        dashboardLoading: action.val
      };
    case SET_CURRENT_PROJECT_ID:
      return {
        ...state,
        currentProjectId: action.id
      };
    case EMPTY_ROUTES:
      return {
        ...state,
        emptyRoutesVisible: action.val
      };
    case SET_DISABLED_VEHICLES_VISIBILITY:
      return {
        ...state,
        disabledVehiclesVisible: action.bool
      };
    case SET_PUBLISH_DISABLED:
      return {
        ...state,
        publishDisabled: action.bool
      };
    case PROJECT_TAB_VALUE:
      return {
        ...state,
        projectTabValue: action.val
      };
    case DRAGGING_TYPE:
      return {
        ...state,
        draggingType: action.val
      };
    case SET_CURRENT_WINDOW:
      return {
        ...state,
        currentWindow: action.val
      };
    case EXPANDED_ROUTES:
      return {
        ...state,
        expandedRoutes: [...action.arr]
      };
    case EXPANDED_FROM_MAP:
      return {
        ...state,
        expandedFromMap: action.bool
      };
    case SET_CURRENT_VEHICLE_SELECTION:
      return {
        ...state,
        currentVehicleSelection: action.arr
      };
    case SET_FILTER_STATUS:
      return {
        ...state,
        filterStatus: action.status
      };
    case FILTER_VEHICLES_BY_STATUS:
      return {
        ...state,
        filteredVehicles: action.arr
      };
    case SELECTED_ROUTES:
      return {
        ...state,
        selectedRoutes: action.arr
      };
    case DRAG_SELECTION:
      return {
        ...state,
        dragSelection: {
          listId: action.listId,
          list: action.list
        }
      };
    case SET_INFO_DIALOG_STATE:
      return {
        ...state,
        infoDialog: action.obj
      };
    case SET_INCOMPLETE_DRAWER_VISIBLE:
      return {
        ...state,
        incompleteAccountVisible: action.bool
      };
    case SET_UPLOAD_STOPS_OPEN:
      return {
        ...state,
        uploadStopsOpen: action.bool
      };
    case SET_UPLOAD_STOPS_SIMPLE_OPEN:
      return {
        ...state,
        uploadStopsSimpleOpen: action.bool
      };
    case SET_PROJECTS_DISABLED:
      return {
        ...state,
        projectsDisabled: action.bool
      };
    case SET_OPTIONS_EXPANDED:
      return {
        ...state,
        optionsExpanded: action.bool
      };
    case SET_STOP_TO_SCROLL_ID:
      return {
        ...state,
        stopToScrollId: action.id
      };
    case SET_LOCKED_MATCH_STOP:
      // Toggle: clicking the pinned stop's tag again clears the lock.
      return {
        ...state,
        lockedMatchStopId:
          state.lockedMatchStopId === action.id ? null : action.id
      };
    case SET_STOP_SEARCH_MODE:
      return {
        ...state,
        isStopSearchMode: action.payload
      };
    case SET_STOP_SELECT_MODE:
      return {
        ...state,
        isStopSelectMode: action.payload
      };
    case SET_ROUTES_SEARCH_MODE:
      return {
        ...state,
        isRoutesSearchMode: action.payload
      };
    case ADD_DRIVER_DIALOG_OPENED:
      return {
        ...state,
        addDriverDialogOpened: action.payload
      };
    case RESET_STATE:
      return {
        ...initialState,
        infoDialog: state.infoDialog,
        dashboardLoading: state.dashboardLoading
      };

    default:
      return state;
  }
}
